module.exports = __webpack_public_path__ + "static/media/img_portfolio@3x.fc6a1919.png";